import React, {useState} from "react"

import { Box } from "@mui/joy";
import { useTranslation } from 'react-i18next';
import { useDataProvider } from "src/mtska-frontend-data-provider";
import JSONPretty from 'react-json-pretty'
import { Icon } from "src/mtska-frontend-app-component/assets";
import InputRuleEditorControl from "./InputRuleEditorControl";
import { Button } from "../Button";

const InputRulesEditorControl = (props) => {
    const { t } = useTranslation();
    const { doAction, saving } = useDataProvider(props.dataProviderName);

    const [loadingAdd, setLoadingAdd] = useState(false);
    const [loadingRemove, setLoadingRemove] = useState(false);

    const addRule = () => {
        setLoadingAdd(true);
        doAction({
            action: 'addRule',
            model: props.dataProviderName,
            data: {
                id: props.item._id
            }
        }).then(() => setLoadingAdd(false));
    }

    const removeRule = (ruleId) => {
        setLoadingRemove(true);
        doAction({
            action: 'removeRule',
            model: props.dataProviderName,
            data: {
                id: props.item._id,
                ruleId: ruleId
            }
        }).then(() => setLoadingRemove(false));
    }

    return (
        <Box className="form-element rulesWrapper col-12" sx={{padding:'20px', border:'1px solid var(--neutral-100)', borderRadius:'10px'}}>
            {/* SONO INPUT RULES
            <JSONPretty data={props.item} className="json-wrapper" />  */}
            <p style={{margin:'10px 0', fontWeight:'700'}}>{t('Rules')}</p>
            <Box className="rulesGridder" sx={{ display: 'grid', gridTemplateColumns: 'repeat(13, 1fr)', gap: '20px 10px' }}>
                {
                    (props.item.rules ?? []).map((rule) => (
                        <>
                            <InputRuleEditorControl {...props} item={rule} autosave={true} />
                            <Button icon="faCircleXmark" loading={loadingRemove} onClick={() => removeRule(rule._id)} family='fas' style={{ color: 'var(--app-main)',  marginTop:'28px', cursor: 'pointer', transition: 'color 0.2s ease', ':hover': { color: 'var(--app-main-shadowed)' } }} />
                        </>
                    ))
                }
            </Box>

            <Button icon="faCirclePlus" onClick={addRule} family='fas' loading={loadingAdd} style={{ color: 'var(--app-main)', marginTop:'20px', cursor: 'pointer', transition: 'color 0.2s ease', ':hover': { color: 'var(--app-main-shadowed)' } }} />
        </Box>
    );
};

export default InputRulesEditorControl;
